import React from 'react'
import styled from 'styled-components'

import { Box, BoxProps } from '../Box'
import { Button } from '../Button'
import { Image } from '../Image'
import { Link } from '../Link'
import { Title } from '../Text'

const HomeProductContainer = styled.div<{ hasLink: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.borderPrimary};
  padding: 5px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  border-radius: ${({ hasLink }) => (hasLink ? '4px 4px 0 0' : '4px')};
  flex: 1 1 auto;
  transition: all 0.15s ease-in-out;
  background: ${({ theme }) => theme.colors.white};
`

const HomeProductButton = styled(Button)`
  border-radius: 0 0 4px 4px;
  transition: all 0.15s ease-in-out;
`

const HomeProductBox = styled(Box).attrs(() => ({
  px: 2,
  py: 2
}))`
  display: flex;
  flex-direction: column;

  &:hover {
    ${HomeProductButton}, ${HomeProductContainer} {
      transform: scale(1.04);
      z-index: 5;
    }
  }
`

const CenterContent = styled.div<{ margin?: string }>`
  display: flex;
  justify-content: center;
  text-align: center;
  ${({ margin }) =>
    margin &&
    `
    margin: ${margin};
  `}
`

const ProductImg = styled(Image)`
  width: 40px;
`

export interface ProductItemProps extends BoxProps {
  description?: string
  image?: string
  title?: string
  link?: {
    url: string
    text: string
  }
  button?: {
    onClick: () => void
    text: string
    icon: React.ReactNode
  }
}

export const ProductItem = ({ description, image, title, link, button, ...rest }: ProductItemProps) => {
  return (
    <HomeProductBox {...rest}>
      <HomeProductContainer hasLink={!!link}>
        {image && (
          <CenterContent margin="20px 0 10px">
            <ProductImg src={image} />
          </CenterContent>
        )}
        {title && (
          <CenterContent margin="10px 0">
            <Title level="medium" text={title} />
          </CenterContent>
        )}
        {description && <CenterContent>{description}</CenterContent>}
        {button && (
          <CenterContent margin="10px">
            <Button onClick={button.onClick} variant="transparent" icon={button.icon}>
              {button.text}
            </Button>
          </CenterContent>
        )}
      </HomeProductContainer>
      {link && (
        <Link to={link.url}>
          <HomeProductButton variant="primary" size="large" block>
            {link.text}
          </HomeProductButton>
        </Link>
      )}
    </HomeProductBox>
  )
}
